<div class="go-layout">
  <ng-content select="[go-layout-header]"></ng-content>
  <div class="go-layout__content">
    <nav>
      <ng-content select="[go-layout-nav]"></ng-content>
    </nav>
    <div class="go-layout__view-container">

      <go-header-bar #headerBar></go-header-bar>

      <main
        class="go-layout__route-container"
        [@routerAnimation]="routeAnimation(mainRouter)"
        #routeContainer>

        <ng-content select="[go-layout-main]"></ng-content>

        <router-outlet
          class="go-layout__route-container-outlet"
          #mainRouter="outlet">
        </router-outlet>

        <ng-content select="[go-layout-footer]"></ng-content>

      </main>

    </div>
  </div>
  <div
    class="go-route-loader"
    *ngIf="routeLoader"
    @fadeTemplate>
    <go-loader></go-loader>
  </div>
</div>

<go-modal></go-modal>
<go-off-canvas></go-off-canvas>
<go-toaster></go-toaster>
